<template>
  <section class="section-project-statistics">
    <h2 v-if="title" class="title title--h2 title--projects-statistics">{{ title }}</h2>
    <div class="section-project-statistics__wrap-nav">
      <template v-if="type === 'portfolio-change-dynamics'">
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponentCheckbox
            v-model="item.CountryIds"
            placeholder="Выберите страны"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            :options="optionCheckboxCountriesDuplicate"
            mod="small"
          />
        </div>
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponentCheckbox
            v-model="item.StatusIds"
            placeholder="Выберите статусы"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            :options="optionCheckboxStatus"
            mod="small"
          />
        </div>
        <div class="section-project-statistics__nav-item">
          <ButtonComponent @click="goToPage('Projects')" mod="gradient-bg">Подробнее</ButtonComponent>
        </div>
      </template>

      <template v-else-if="type === 'dynamics-quantity-status-inclusion-exclusion'">
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.CountryId"
            :options="optionCountries"
            placeholder="Выберите страну"
            modifier="rectangular"
            :canDeselect="false"
          />
        </div>
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.mpkComissionId"
            :options="projectMPKPortfolioOptions"
            placeholder="Выберите МПК"
            modifier="rectangular"
            :canClear="true"
          />
        </div>
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.mpkEventMeetingId"
            :options="mpkEventOptions"
            placeholder="Выберите мероприятие"
            modifier="rectangular"
            :canClear="true"
          />
        </div>
        <div class="section-project-statistics__nav-item">
          <ButtonComponent @click="$emit('click-more')" mod="gradient-bg">Подробнее</ButtonComponent>
        </div>
      </template>
      <template v-else-if="type === 'distribution-of-projects'">
        <div class="section-project-statistics__nav-item select">
          <span class="label-field">Страна</span>
          <SelectMultiComponentCheckbox
            v-model="item.CountryIds"
            placeholder="Все"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            :options="optionCheckboxCountriesDuplicate"
            mod="small"
          />
        </div>
        <div class="section-project-statistics__nav-item select">
          <span class="label-field">Статус</span>
          <SelectMultiComponentCheckbox
            v-model="item.StatusIds"
            placeholder="Все"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            :options="optionCheckboxStatus"
            mod="small"
          />
        </div>
        <div class="section-project-statistics__nav-item">
          <ButtonComponent @click="$emit('click-more')" mod="gradient-bg">Подробнее</ButtonComponent>
        </div>
      </template>

      <template v-else-if="type === 'number-jobs-created'">
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.countryId"
            :options="optionCountries"
            placeholder="Выберите страну"
            modifier="rectangular"
            class="visible-clear"
          />
        </div>
        <div class="section-project-statistics__nav-item">
          <ButtonComponent @click="goToPage('Projects')" mod="gradient-bg">Подробнее</ButtonComponent>
        </div>
      </template>

      <template v-else-if="type === 'share-green-projects'">
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.countryId"
            :options="optionCountries"
            placeholder="Выберите страну"
            modifier="rectangular"
            class="visible-clear"
          />
        </div>
        <div class="section-project-statistics__nav-item select">
          <SelectMultiComponent
            v-model="item.mpkEventMeetingId"
            :options="optionProjectsMPKPortfolio"
            placeholder="За все время"
            modifier="rectangular"
            class="visible-clear"
          />
        </div>
        <div class="section-project-statistics__nav-item">
          <ButtonComponent @click="goToPage('Projects')" mod="gradient-bg">Подробнее</ButtonComponent>
        </div>
      </template>
    </div>
    <div
      class="section-project-statistics__wrap-nav"
      v-if="type === 'dynamics-quantity-status-inclusion-exclusion' || type === 'number-jobs-created'"
    >
      <div
        v-if="type === 'dynamics-quantity-status-inclusion-exclusion'"
        class="section-project-statistics__nav-item select"
      >
        <SelectMultiComponent
          v-model="item.DynamicMode"
          :options="optionProjectMPK"
          placeholder=""
          modifier="rectangular"
        />
      </div>
      <div class="section-project-statistics__date-wrapper">
        <p class="section-project-statistics__nav-item label-field">Выберите период</p>
        <div class="section-project-statistics__date-inputs">
          <div class="section-project-statistics__nav-item select">
            <DateComponent
              v-model="item.CustomPeriodFrom"
              mode="year"
              :clearable="false"
              placeholder="Выберите"
              dateIcon
              modClass="redesigned small"
              :id="idPeriodFrom"
            />
          </div>
          <span class="section-project-statistics__hyphen"></span>
          <div class="section-project-statistics__nav-item select">
            <DateComponent
              v-model="item.CustomPeriodTo"
              mode="year"
              :clearable="false"
              placeholder="Выберите"
              dateIcon
              modClass="redesigned small"
              :id="idPeriodTo"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="section-project-statistics__content">
      <slot />
    </div>
  </section>
</template>

<script>
  import moment from 'moment';

  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import constants from '../constants';

  export default {
    name: 'SectionStatistics',
    components: {
      SelectMultiComponentCheckbox,
      ButtonComponent,
      DateComponent,
      SelectMultiComponent,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: '',
        validator(value) {
          return [
            'portfolio-change-dynamics',
            'dynamics-quantity-status-inclusion-exclusion',
            'number-jobs-created',
            'share-green-projects',
            'distribution-of-projects',
          ].includes(value);
        },
      },
      optionCheckboxCountries: {
        type: Array,
        default: () => [],
      },
      optionCheckboxStatus: {
        type: Array,
        default: () => [],
      },
      optionCountries: {
        type: Array,
        default: () => [],
      },
      optionProjectsMPKPortfolio: {
        type: Array,
        default: () => [],
      },
      optionEvents: {
        type: Array,
        default: () => [],
      },
      optionProjectMPK: {
        type: Array,
        default: () => [],
      },
      filterMpkData: {
        type: Object,
        default: () => {},
      },
      idPeriodFrom: String,
      idPeriodTo: String,
    },
    data() {
      return {
        optionCheckboxCountriesDuplicate: [],
        item: {
          CountryIds: [...(this.filterMpkData?.countryIds ?? [])],
          StatusIds: [],
          CountryId: this.filterMpkData?.CountryId ?? '',
          MpkEventMeetingId: '',
          DynamicMode: constants.DEFAULT_DYNAMIC,
          CustomPeriodFrom: '',
          CustomPeriodTo: '',
          countryId: this.filterMpkData?.countryId ?? '',
          mpkComissionId: '',
          mpkEventMeetingId: '',
        },
        projectMPKPortfolioOptions: [...(this.optionProjectsMPKPortfolio ?? [])],
        mpkEventOptions: [...(this.optionEvents ?? [])],
        countryDisabled: false,
      };
    },
    watch: {
      'item.CountryId': {
        handler() {
          this.projectMPKPortfolioOptions = [];
          this.item.mpkComissionId = '';
          this.item.mpkEventMeetingId = '';
        },
      },
      'item.mpkComissionId': {
        handler() {
          this.mpkEventOptions = [];
          this.item.mpkEventMeetingId = '';
        },
      },
      item: {
        handler(val) {
          this.eventChangeData(val);
        },
        deep: true,
      },
      optionCheckboxCountries: {
        handler() {
          this.optionCheckboxCountriesDuplicate = JSON.parse(JSON.stringify(this.optionCheckboxCountries));
        },
        deep: true,
      },
      optionProjectsMPKPortfolio: {
        handler(newVal) {
          this.projectMPKPortfolioOptions = newVal;
        },
        deep: true,
      },
      optionEvents: {
        handler(newVal) {
          this.mpkEventOptions = newVal;
        },
        deep: true,
      },
      filterMpkData: {
        handler(newVal) {
          this.item.CountryIds = newVal?.countryIds ? newVal.countryIds : [];
          this.item.StatusIds = newVal?.statusIds ? newVal.statusIds : [];
          this.item.CountryId = this.filterMpkData?.CountryId;
        },
        deep: true,
      },
      'item.CountryIds'(val) {
        this.disableList(val);
      },
      'item.countryId'() {
        if (this.type === constants.TYPE_SECTION_SGP) {
          this.item.mpkEventMeetingId = null;
        }
      },
      'item.CustomPeriodTo'(newValue) {
        if (!newValue) return;

        const endOfSelectedYear = moment(newValue).endOf('year').format('YYYY-MM-DD');
        if (newValue !== endOfSelectedYear) {
          this.item.CustomPeriodTo = endOfSelectedYear;
        }
      },
    },
    methods: {
      goToPage() {
        this.$emit('click-more');
      },

      eventChangeData(data) {
        const {
          CountryIds = [],
          StatusIds = [],
          CountryId = '',
          DynamicMode = '',
          CustomPeriodFrom = '',
          CustomPeriodTo = '',
          countryId = '',
          mpkComissionId = '',
          mpkEventMeetingId = '',
        } = data;

        if (this.type === constants.TYPE_SECTION_PHD) {
          this.$emit('changeData', {
            CountryIds,
            StatusIds,
          });
        }
        if (this.type === constants.TYPE_SECTION_DQSIE) {
          this.$emit('changeData', {
            CountryId,
            mpkComissionId,
            mpkEventMeetingId,
            DynamicMode,
            CustomPeriodFrom,
            CustomPeriodTo,
          });
        }
        if (this.type === constants.TYPE_SECTION_NJC) {
          this.$emit('changeData', {
            countryId,
            CustomPeriodFrom,
            CustomPeriodTo,
          });
        }
        if (this.type === constants.TYPE_SECTION_SGP) {
          this.$emit('changeData', {
            countryId,
            mpkEventMeetingId,
          });
        }
        if (this.type === constants.TYPE_SECTION_DOP) {
          this.$emit('changeData', {
            CountryIds,
            StatusIds,
          });
        }
      },

      disableList(listId) {
        if (this.countryDisabled) {
          this.optionCheckboxCountriesDuplicate = this.optionCheckboxCountriesDuplicate.map((i) => ({
            ...i,
            disabled: false,
          }));
          this.countryDisabled = false;
        }

        if (listId.length >= 10) {
          this.optionCheckboxCountriesDuplicate = this.optionCheckboxCountriesDuplicate.map((i) => ({
            ...i,
            disabled: true,
          }));

          this.optionCheckboxCountriesDuplicate.forEach((i) => {
            listId.forEach((j) => {
              if (+i.id === +j) {
                i.disabled = false;
              }
            });
          });
          this.countryDisabled = true;
        }
      },
    },
  };
</script>

<style lang="scss">
  @import '@/assets/theme/default/title.scss';
  .section-project-statistics {
    margin-bottom: 40px;

    &__wrap {
      &-nav {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;
        align-items: flex-end;
      }
    }

    &__nav-item {
      margin: 0 8px 24px;

      &.select {
        width: 308px;
      }
    }

    &__date-wrapper {
      display: flex;
      flex-direction: column;
    }

    &__date-inputs {
      display: flex;
      align-items: center;
    }

    &__hyphen {
      width: 8px;
      height: 2px;
      display: inline-block;
      background: $base;
      margin-bottom: 24px;
    }

    &.distribution-of-projects {
      & .section-project-statistics__wrap-nav {
        align-items: flex-end;
      }
    }

    .full {
      width: 100%;
      margin-bottom: 8px;
    }

    @media (max-width: $laptop) {
      &__hyphen {
        display: none;
      }
    }

    @media (max-width: $mobile) {
      &__nav-item {
        margin-bottom: 16px;

        &.select {
          width: 100%;
        }
      }
    }
  }
</style>
